"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DropdownHeader;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
/**
 * Create a header which can highlight a set of DropdownItems.
 *
 * @class DropdownHeader
 * @displayName DropdownHeader (Web)
 * @public
 */
function DropdownHeader(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    role: "heading",
    "aria-level": "1",
    className: "dropdown-header title small"
  }, children);
}

/**
 * Children should be provided.
 *
 * @enum {Object} propTypes
 * @public
 */
DropdownHeader.propTypes = {
  /** Contents of a dropdown header */
  children: _propTypes.default.node.isRequired
};